import { render, staticRenderFns } from "./splitFee.vue?vue&type=template&id=c3caa4fc&scoped=true"
import script from "./splitFee.vue?vue&type=script&lang=js"
export * from "./splitFee.vue?vue&type=script&lang=js"
import style0 from "./splitFee.vue?vue&type=style&index=0&id=c3caa4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3caa4fc",
  null
  
)

export default component.exports